import React, { useEffect } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { BoatFinderQuiz } from './components/BoatFinderQuiz';
import { FleetCatalog } from './components/FleetCatalog';
import { PremiumFleet } from './components/PremiumFleet';
import { JetSkiSection } from './components/JetSkiSection';
import { LicenseSection } from './components/LicenseSection';
import { HowItWorks } from './components/HowItWorks';
import { WhyKevinBoats } from './components/WhyKevinBoats';
import { Gallery } from './components/Gallery';
import { ContactSection } from './components/ContactSection';
import { Reviews } from './components/Reviews';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
const MainApp = () => {
  useEffect(() => {
    document.title = 'Kevin Boats | Alquiler de Barcos en Torrevieja sin Licencia';
  }, []);
  return <div className="min-h-screen bg-white font-sans text-navy selection:bg-turquoise selection:text-navy" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <BoatFinderQuiz data-id="element-5" />
        <FleetCatalog data-id="element-6" />
        <PremiumFleet data-id="element-7" />
        <JetSkiSection data-id="element-8" />
        <LicenseSection data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <WhyKevinBoats data-id="element-11" />
        <Gallery data-id="element-12" />
        <ContactSection data-id="element-13" />
        <Reviews data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <FloatingWhatsApp data-id="element-16" />
    </div>;
};
export function App() {
  return <LanguageProvider data-id="element-17">
      <MainApp data-id="element-18" />
    </LanguageProvider>;
}